/** Valeurs API du dernier diplôme obtenu (Case), communes au formulaire et aux envois.
 * Les dossiers historiques contiennent « N - … » au lieu de « N … ».
 * On ne convertit que les alias exacts connus, jamais les autres listes.
 */
const DIPLOMA_OPTIONS = [
  {
    "id": 1,
    "value": "A BACCALAURÉAT (FRANÇAIS, et PAS étranger)",
    "text": "A BACCALAURÉAT (FRANÇAIS, et PAS étranger)"
  },
  {
    "id": 2,
    "value": "B BTS",
    "text": "B BTS"
  },
  {
    "id": 3,
    "value": "C DUT ou DUT intermédiaire",
    "text": "C DUT ou DUT intermédiaire"
  },
  {
    "id": 4,
    "value": "D Attestation délivrée à la suite d’un cursus en CPGE, y compris ATS (adaptation technicien supérieur)",
    "text": "D Attestation délivrée à la suite d’un cursus en CPGE, y compris ATS (adaptation technicien supérieur)"
  },
  {
    "id": 5,
    "value": "E Diplôme d’INGÉNIEUR (UNIVERSITAIRE OU NON)",
    "text": "E Diplôme d’INGÉNIEUR (UNIVERSITAIRE OU NON)"
  },
  {
    "id": 6,
    "value": "F Diplôme universitaire D’ENTRÉE EN 1er CYCLE",
    "text": "F Diplôme universitaire D’ENTRÉE EN 1er CYCLE"
  },
  {
    "id": 7,
    "value": "I DEUG (y compris DEUG intermédiaire, DEUG IUP et DEUP)",
    "text": "I DEUG (y compris DEUG intermédiaire, DEUG IUP et DEUP)"
  },
  {
    "id": 8,
    "value": "K Attestation de fin de 1ere année de médecine, de pharmacie et d'odontologie",
    "text": "K Attestation de fin de 1ere année de médecine, de pharmacie et d'odontologie"
  },
  {
    "id": 9,
    "value": "L Diplôme du secteur PARAMÉDICAL ET SOCIAL",
    "text": "L Diplôme du secteur PARAMÉDICAL ET SOCIAL"
  },
  {
    "id": 10,
    "value": "M Autre diplôme universitaire de 1ER CYCLE hors DUT",
    "text": "M Autre diplôme universitaire de 1ER CYCLE hors DUT"
  },
  {
    "id": 11,
    "value": "N LICENCE, LICENCE LMD, Bachelor universitaire de technologie (BUT) et Bachelors en Sciences et technologie conférant le grade de licence",
    "text": "N LICENCE, LICENCE LMD, Bachelor universitaire de technologie (BUT) et Bachelors en Sciences et technologie conférant le grade de licence"
  },
  {
    "id": 12,
    "value": "Q MAÎTRISE (y compris MAITRISE intermédiaire)",
    "text": "Q MAÎTRISE (y compris MAITRISE intermédiaire)"
  },
  {
    "id": 13,
    "value": "R Autre diplôme universitaire de 2ème CYCLE (hors diplôme d'ingénieur universitaire)",
    "text": "R Autre diplôme universitaire de 2ème CYCLE (hors diplôme d'ingénieur universitaire)"
  },
  {
    "id": 14,
    "value": "U Diplôme universitaire de 3ème CYCLE : DEA-DESS+ Master LMD+ Docteur en médecine...(hors diplôme d’ingénieur)",
    "text": "U Diplôme universitaire de 3ème CYCLE : DEA-DESS+ Master LMD+ Docteur en médecine...(hors diplôme d’ingénieur)"
  },
  {
    "id": 15,
    "value": "V Diplôme de fin de 2e cycle des études médicales et pharmaceutiques",
    "text": "V Diplôme de fin de 2e cycle des études médicales et pharmaceutiques"
  },
  {
    "id": 16,
    "value": "X Diplôme d'établissement ÉTRANGER supérieur ou secondaire",
    "text": "X Diplôme d'établissement ÉTRANGER supérieur ou secondaire"
  },
  {
    "id": 17,
    "value": "Y AUTRE diplôme supérieur",
    "text": "Y AUTRE diplôme supérieur"
  },
  {
    "id": 18,
    "value": "Z AUCUN diplôme supérieur",
    "text": "Z AUCUN diplôme supérieur"
  },
  {
    "id": 19,
    "value": "1 Diplôme d'établissement ÉTRANGER secondaire",
    "text": "1 Diplôme d'établissement ÉTRANGER secondaire"
  },
  {
    "id": 20,
    "value": "2 Diplôme d'établissement ÉTRANGER supérieur",
    "text": "2 Diplôme d'établissement ÉTRANGER supérieur"
  },
  {
    "id": 21,
    "value": "3 Diplôme de formation générale de santé – grade licence",
    "text": "3 Diplôme de formation générale de santé – grade licence"
  },
  {
    "id": 22,
    "value": "4 Diplôme de formation approfondie de santé – grade master",
    "text": "4 Diplôme de formation approfondie de santé – grade master"
  }
];
const DIPLOMA_FIELD_IDS = new Set(['00NaT000000KxK5', '00NaT0000001LC5']);
const LEGACY_VALUES = new Map(DIPLOMA_OPTIONS.map(({ value }) => [
  value.replace(/^([A-Z1-4]) /, '$1 - '), value
]));

function normalizeDiplomaValue(value) {
  return LEGACY_VALUES.get(value) || value;
}

function normalizeSalesforceValue(fieldId, value) {
  return DIPLOMA_FIELD_IDS.has(String(fieldId)) ? normalizeDiplomaValue(value) : value;
}

module.exports = { DIPLOMA_OPTIONS, normalizeDiplomaValue, normalizeSalesforceValue };
